import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/aidyn/server/projects/optovichok/frontend/src/app/homepage/components/HomepageInteractive.tsx");
